/**
 * Opciones del filtro por estado de la validacion de cedula.
 *
 * Vive en un solo lugar a proposito: el mismo filtro aparece en seis tablas
 * de tres pantallas distintas, y si cada una declarara su lista, alcanzaria
 * con que alguien agregara una opcion en un lado para que las pantallas
 * empiecen a mostrar cosas distintas sobre los mismos datos.
 *
 * LA ETIQUETA NO ES EL VALOR. En pantalla se lee en castellano; lo que viaja
 * al backend es el veredicto que produce el motor. Son dos vocabularios
 * distintos y conviene no mezclarlos: "requiere_recaptura" no es algo que
 * deba leer un reclutador.
 *
 * "Datos validados" manda "validado" y el backend agrega "completado" por su
 * cuenta -- para quien revisa son lo mismo, y la distincion es del motor.
 *
 * "Validado manualmente" va aparte a proposito: lo resolvio una persona, no
 * el motor, y quien filtra suele querer distinguir justamente eso.
 *
 * Es la MISMA lista que usa la tabla de postulaciones (TablaPostulaciones la
 * toma de aca): el filtro "Validacion" ofrece los mismos estados en todas las
 * pantallas.
 *
 * "Sin validar" no es un veredicto sino la ausencia de uno: el backend lo
 * traduce a IS NULL. Se manda como SIN_VALIDAR, en mayusculas, justamente
 * para que no se confunda con un veredicto real.
 */
export interface IOpcionFiltroCedula {
  etiqueta: string;
  valor: string;
}

export const OPCIONES_FILTRO_CEDULA: IOpcionFiltroCedula[] = [
  { etiqueta: "Datos validados",      valor: "validado"           },
  { etiqueta: "Corregido por IA",     valor: "corregido_IA"       },
  { etiqueta: "Validado manualmente", valor: "validado_manual"    },
  { etiqueta: "Revisar cédula",       valor: "requiere_revision"  },
  { etiqueta: "Repetir foto",         valor: "requiere_recaptura" },
  { etiqueta: "Sin validar",          valor: "SIN_VALIDAR"        },
];
